module.exports = __webpack_public_path__ + "img/【诊改行动】数“智”赋能，“阳”帆启航！上电智联助力阳城汽配启动轻量级数字化改造项目.198823d4.jpg";